/**
 * image block on touch screen:
 * 		first click --> do hover effect
 * 		second click --> go to the link
 */

'use strict';

import $ from 'jquery';

$(document).ready(function(){

	let imageBlock = $('.paragraph--type--call-to-action-internal-links')
				.add('.paragraph--type--ia-chapter-doc');

	let touchmoved;
	imageBlock.on('touchend', function(e){
		if(touchmoved == true){
			return;
		}
		e.preventDefault();
		if ($(this).hasClass('hovered') ){
			window.location.href = $(this).find('a').attr('href');
		} else {
			disableAllHover();
			$(this).addClass('hovered');
		}
	}).on('touchmove', function(){
		touchmoved = true;
	}).on('touchstart', function(){
		touchmoved = false;
	});

	$(document).on('touchstart', function(e) {
		if (!$(e.target).closest(imageBlock).length) {
			disableAllHover();
		}
	});

	function disableAllHover(){
		imageBlock.removeClass('hovered');
	}
})